// Timezone-safe Date to ISO string converter

export const apiDate = (date?: string) => {
    if (!date) {
        return ''
    }
    const parts = date.split('/')
    if (parts.length !== 3) {
        return ''
    }
    return `${parts[2]}-${parts[0]}-${parts[1]}`
}

const isoDate = (date: Date) => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()

export default isoDate
